var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTracktor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.60002L8.30002 5.80002L7.50002 2.40002H2.40002V5.90002C2.60002 5.90002 2.90002 5.90002 3.10002 5.90002C5.30002 5.90002 7.10002 7.70002 7.10002 9.90002C7.10002 12.1 7.10002 10.3 7.10002 10.5H8.40002H9.90002H12.2C13 10.5 13.6 9.90002 13.6 9.10002V8.00002C13.6 7.40002 13.2 6.90002 12.6 6.80002L12.5 6.60002Z",
    fill: "#D7E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.90002V5.90002",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 3.30005H11V5.00005",
    stroke: "#4147D5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.79995C0.5 11.2 1.6 12.4 3.1 12.4C4.6 12.4 5.7 11.3 5.7 9.79995C5.7 8.29995 4.6 7.19995 3.1 7.19995C1.6 7.19995 0.5 8.29995 0.5 9.79995Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.79995C0.5 11.2 1.6 12.4 3.1 12.4C4.6 12.4 5.7 11.3 5.7 9.79995C5.7 8.29995 4.6 7.19995 3.1 7.19995C1.6 7.19995 0.5 8.29995 0.5 9.79995Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09998 9.79993C2.09998 10.2999 2.49998 10.7999 3.09998 10.7999C3.69998 10.7999 4.09998 10.3999 4.09998 9.79993C4.09998 9.19993 3.69998 8.79993 3.09998 8.79993C2.49998 8.79993 2.09998 9.19993 2.09998 9.79993Z",
    fill: "#4147D5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.90005V7.80005C13.5 7.20005 13.1 6.70005 12.5 6.60005L8.30005 5.80005V10.3H12.1C12.9 10.3 13.5 9.70005 13.5 8.90005Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30002 1.59998H7.50002C7.70002 1.59998 7.90002 1.79998 7.90002 1.99998C7.90002 2.19998 7.70002 2.39998 7.50002 2.39998H2.30002C2.10002 2.39998 1.90002 2.19998 1.90002 1.99998C1.90002 1.79998 2.10002 1.59998 2.30002 1.59998Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30005 2.40002V5.80002H8.30005",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.19995H10.3",
    stroke: "#4147D5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.90002H10.3",
    stroke: "#4147D5",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29995 10.3H6.99995C6.99995 10.1 6.99995 9.89995 6.99995 9.69995C6.99995 7.49995 5.19995 5.69995 2.99995 5.69995C0.799948 5.69995 2.49995 5.69995 2.29995 5.69995V2.19995H7.39995L8.19995 5.59995",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40002 10.8C9.40002 11.7 10.1 12.4 11 12.4C11.9 12.4 12.6 11.7 12.6 10.8C12.6 9.89995 11.9 9.19995 11 9.19995C10.1 9.19995 9.40002 9.89995 9.40002 10.8Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40002 10.8C9.40002 11.7 10.1 12.4 11 12.4C11.9 12.4 12.6 11.7 12.6 10.8C12.6 9.89995 11.9 9.19995 11 9.19995C10.1 9.19995 9.40002 9.89995 9.40002 10.8Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTracktor);
export default __webpack_public_path__ + "static/media/icon-tracktor.4f7e34557ca3e866b17fbc9c8481f3ec.svg";
export { ForwardRef as ReactComponent };